
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import AccountBalanceChart from "@/superannuation/AccountBalanceChart.vue"
import SsComponentPage from "@/report/pages/SsComponentPage.vue"

@Component({
  name: "SsBalancePage",
  components: {
    SsComponentPage,
    AccountBalanceChart,
  },
})
export default class SsBalancePage extends AbstractPage {}
